// String constants for the application
import { ASKME_COMMANDS, COMMAND_CATEGORIES } from './askme_commands.js';

export const STRINGS = {
  // Dialog messages
  DIALOGS: {
    UNSUPPORTED_FEATURE: {
      TITLE: 'Not available on the dashboard',
      SUBTITLE: 'This can be done in the SchoolLine app',
      REASON_TITLE: 'Why?',
      REASON_TEXT: `The dashboard is for viewing and reporting on a large screen. Changes to student and staff records are made in the SchoolLine app, so every change is checked and recorded in one place.`,
      ALTERNATIVES_TITLE: 'Alternative Solutions',
      ALTERNATIVES: [
        'Contact your system administrator for data modifications',
        'Use the dedicated administrative interface',
        'Submit a formal request through proper channels'
      ],
      NOTE: 'This restriction helps maintain data consistency and ensures all student information changes are properly tracked and authorized.',
      BUTTON_OK: 'OK',
      BUTTON_CLOSE: 'Close',
      BUTTON_UNDERSTAND: 'I Understand'
    },
    CONFIRM_DELETE: {
      TITLE: 'Confirm Delete',
      MESSAGE: 'Are you sure you want to delete this item?',
      BUTTON_DELETE: 'Delete',
      BUTTON_CANCEL: 'Cancel'
    },
    APP_UPDATE: {
      TITLE: 'App Update Available',
      SUBTITLE: 'A new version is ready to install',
      MESSAGE: 'A new version of the application is available. Updating will refresh the app with the latest features and improvements.',
      BUTTON_UPDATE: 'Update Now',
      BUTTON_LATER: 'Later',
      UPDATING: 'Updating...'
    }
  },

  // Page titles and headers
  PAGES: {
    STUDENT_MANAGEMENT: {
      TITLE: 'Student Management',
      SUBTITLE: 'Manage student information and academic records',
      SEARCH_TITLE: 'Student Search',
      STUDENTS_FOUND: 'Students Found',
      NO_STUDENTS: 'No Students Found',
      NO_STUDENTS_MESSAGE: 'Select a class and section to view students.',
      LOADING: 'Loading students...',
      SEARCHING: 'Searching...',
      RETRY: 'Retry'
    },
    STUDENT_DETAILS: {
      TITLE: 'Student Details',
      SUBTITLE: 'View and manage student information',
      BACK: '← Back',
      NOTICE: 'Editing and uploading student data are currently not supported on the dashboard.',
      LEARN_MORE: 'Learn more',
      SECTIONS: {
        PERSONAL: 'Personal Information',
        ACADEMIC: 'Academic Information',
        CONTACT: 'Contact Information',
        FAMILY: 'Family Information',
        ACCOUNT: 'Account Information'
      }
    }
  },

  // Form labels
  FORMS: {
    LABELS: {
      CLASS: 'Class',
      SECTION: 'Section',
      SEARCH_STUDENTS: 'Search Students',
      FULL_NAME: 'Full Name',
      GENDER: 'Gender',
      DATE_OF_BIRTH: 'Date of Birth',
      AGE: 'Age',
      NATIONALITY: 'Nationality',
      ADMISSION_NUMBER: 'Admission Number',
      STUDENT_ID: 'Student ID'
    },
    PLACEHOLDERS: {
      SELECT_CLASS: 'Select Class',
      SELECT_SECTION: 'Select Section',
      SEARCH_PLACEHOLDER: 'Search by name, ID, email...',
      LOADING_CLASSES: 'Loading classes...',
      LOADING_SECTIONS: 'Loading sections...',
      SELECT_CLASS_FIRST: 'Select class first'
    }
  },

  // Common messages
  COMMON: {
    LOADING: 'Loading...',
    ERROR: 'Error',
    SUCCESS: 'Success',
    SAVE: 'Save',
    CANCEL: 'Cancel',
    DELETE: 'Delete',
    EDIT: 'Edit',
    VIEW: 'View',
    SEARCH: 'Search',
    NOT_AVAILABLE: 'N/A',
    REQUIRED: 'Required',
    OPTIONAL: 'Optional'
  },

  // Error messages
  ERRORS: {
    GENERAL: 'An error occurred. Please try again.',
    NETWORK: 'Network error. Please check your connection.',
    PERMISSION: 'You do not have permission to perform this action.',
    NOT_FOUND: 'The requested resource was not found.',
    VALIDATION: 'Please fill in all required fields.',
    SCHOOL_CONTEXT: 'School context not available. Please select a school first.'
  },

  // Success messages
  SUCCESS: {
    SAVED: 'Data saved successfully',
    UPDATED: 'Data updated successfully',
    DELETED: 'Data deleted successfully',
    UPLOADED: 'File uploaded successfully'
  },

  // Table headers
  TABLE: {
    HEADERS: {
      STUDENT: 'Student',
      CLASS_SECTION: 'Class & Section',
      STATUS: 'Status',
      PARENT_INFO: 'Parent Info',
      ACTIONS: 'Actions'
    },
    ACTIONS: {
      EDIT: 'Edit',
      VIEW_DETAILS: 'View Details',
      ACADEMIC_RECORDS: 'Academic Records'
    }
  },

  // Status labels
  STATUS: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    BLOCKED: 'Blocked',
    PENDING: 'Pending'
  },

  // AskMe Commands
  ASKME: {
    COMMANDS: ASKME_COMMANDS,
    CATEGORIES: COMMAND_CATEGORIES,
    COMMAND_TRIGGER: '/',
    PLACEHOLDER_TEXT: 'Type / to see available commands',
    NO_COMMANDS_FOUND: 'No commands found',
    SELECT_COMMAND: 'Select a command'
  }
};

// Legacy export for backward compatibility
export default STRINGS; 